(function () {
  'use strict';

  function initMainProduct(root) {
    if (!root || root.dataset.esPdpInitialized === 'true') return;
    root.dataset.esPdpInitialized = 'true';

    var gallery = root.querySelector('[data-es-product-gallery]');
    var thumbs = gallery ? gallery.querySelectorAll('[data-es-product-thumb]') : [];
    var mediaItems = gallery ? gallery.querySelectorAll('[data-es-product-media]') : [];

    function showMedia(mediaId) {
      if (!mediaId) return;

      mediaItems.forEach(function (item) {
        var active = item.getAttribute('data-media-id') === String(mediaId);
        item.hidden = !active;
        item.classList.toggle('is-active', active);

        if (!active) {
          item.querySelectorAll('video').forEach(function (video) {
            if (!video.paused) video.pause();
          });
        }
      });

      thumbs.forEach(function (thumb) {
        var active = thumb.getAttribute('data-media-id') === String(mediaId);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showMedia(thumb.getAttribute('data-media-id'));
      });
    });

    var qtyInput = root.querySelector('[data-es-qty-input]');
    var qtyMinus = root.querySelector('[data-es-qty-minus]');
    var qtyPlus = root.querySelector('[data-es-qty-plus]');

    function normalizeQty(value) {
      var parsed = parseInt(value, 10);
      if (!Number.isFinite(parsed) || parsed < 1) return 1;
      return parsed;
    }

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        qtyInput.value = Math.max(1, normalizeQty(qtyInput.value) - 1);
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function () {
        qtyInput.value = normalizeQty(qtyInput.value) + 1;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        qtyInput.value = normalizeQty(qtyInput.value);
      });
    }

    var variantSelect = root.querySelector('[data-es-variant-select]');
    var price = root.querySelector('[data-es-price]');
    var compare = root.querySelector('[data-es-compare-price]');
    var availability = root.querySelector('[data-es-availability]');
    var addButton = root.querySelector('[data-es-add-button]');
    var addText = root.querySelector('[data-es-add-text]');
    var saleBadge = root.querySelector('[data-es-sale-badge]');

    function updateVariant() {
      if (!variantSelect) return;

      var option = variantSelect.options[variantSelect.selectedIndex];
      if (!option) return;

      var available = option.dataset.available === 'true';
      var variantPrice = option.dataset.price || '';
      var comparePrice = option.dataset.compare || '';
      var mediaId = option.dataset.mediaId || '';

      if (price) price.textContent = variantPrice;

      if (compare) {
        if (comparePrice) {
          compare.textContent = comparePrice;
          compare.hidden = false;
        } else {
          compare.textContent = '';
          compare.hidden = true;
        }
      }

      if (saleBadge) {
        if (comparePrice) {
          saleBadge.textContent = 'Sale';
          saleBadge.hidden = false;
        } else {
          saleBadge.hidden = true;
        }
      }

      if (availability) {
        availability.classList.toggle('is-unavailable', !available);
        var label = availability.querySelector('span:last-child');
        if (label) label.textContent = available ? 'In stock' : 'Sold out';
      }

      if (addButton) addButton.disabled = !available;
      if (addText) addText.textContent = available ? 'Add to Cart' : 'Sold Out';

      if (mediaId) showMedia(mediaId);

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (variantSelect) {
      variantSelect.addEventListener('change', updateVariant);
    }

    var countdown = root.querySelector('[data-es-offer-countdown]');
    if (countdown) {
      var durationHours = parseInt(countdown.getAttribute('data-duration-hours') || '6', 10);
      if (!Number.isFinite(durationHours) || durationHours < 1) durationHours = 6;
      var storageKey = countdown.getAttribute('data-storage-key') || ('es-offer-' + (root.id || 'default'));
      var timerId = null;
      var expiresAt = 0;

      function padTimer(value) {
        return String(Math.max(0, value)).padStart(2, '0');
      }

      function createExpiry() {
        return Date.now() + (durationHours * 60 * 60 * 1000);
      }

      function readStoredExpiry() {
        try {
          var raw = window.localStorage ? window.localStorage.getItem(storageKey) : null;
          var parsed = raw ? parseInt(raw, 10) : NaN;
          if (Number.isFinite(parsed) && parsed > Date.now()) return parsed;
        } catch (error) {}
        return NaN;
      }

      function saveExpiry(value) {
        try {
          if (window.localStorage) window.localStorage.setItem(storageKey, String(value));
        } catch (error) {}
      }

      function getOrCreateExpiry() {
        var stored = readStoredExpiry();
        if (Number.isFinite(stored) && stored > Date.now()) return stored;
        var freshExpiry = createExpiry();
        saveExpiry(freshExpiry);
        return freshExpiry;
      }

      function resetCountdown() {
        expiresAt = createExpiry();
        saveExpiry(expiresAt);
      }

      expiresAt = getOrCreateExpiry();

      function updateCountdown() {
        var remaining = expiresAt - Date.now();
        if (remaining <= 0) {
          resetCountdown();
          remaining = expiresAt - Date.now();
        }

        countdown.hidden = false;
        var totalSeconds = Math.floor(remaining / 1000);
        var hours = Math.floor(totalSeconds / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;
        var map = {
          '[data-es-hours]': hours,
          '[data-es-minutes]': minutes,
          '[data-es-seconds]': seconds
        };

        Object.keys(map).forEach(function (selector) {
          var element = countdown.querySelector(selector);
          if (element) element.textContent = padTimer(map[selector]);
        });
      }

      updateCountdown();
      timerId = window.setInterval(updateCountdown, 1000);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-es-main-product]').forEach(initMainProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();